import React from 'react';

const About: React.FC = () => {
  return (
    <section id="about">
      <div className="container">
        <h2>About Us</h2>
        <p>
          At goTuna, we specialize in delivering top-notch technology solutions that drive business success. 
          Our team of experts is dedicated to providing innovative and customized services to meet your unique needs.
        </p>
      </div>
    </section>
  );
};

export default About; 